export class DateUtils {

    public getMxDate(date: string = '', daysAdded: number): number {
        const d = date === '' ? new Date() : new Date(date);
        d.setDate(d.getDate() + daysAdded);
        return d.getTime();
    }
}
